import { Component, OnInit, Input } from '@angular/core';
import { ReportService } from '@app/core';

@Component({
  selector: 'app-visitordoughnutchart',
  templateUrl: './visitordoughnutchart.component.html',
  styleUrls: ['./visitordoughnutchart.component.scss']
})
export class VisitordoughnutchartComponent implements OnInit {
  @Input() filterData: any;

  pieData: any;
  // pieData = [
  //   ['Work',     11],
  //   ['Eat',      2],
  //   ['Commute',  2],
  //   ['Watch TV', 2],
  //   ['Sleep',    7]
  // ]

  pieOptions = {
    title: 'My Daily Activities',
    pieHole: 0.2,
  };

  constructor(private reportService: ReportService) { }

  ngOnChanges() {
    console.log(this.filterData);
    this.getVisitorPieData(this.filterData);
  }
  ngOnInit() {
    console.log(this.filterData);
    this.getVisitorPieData("Today");
  }
  getVisitorPieData(filter: string) {
    this.reportService.getVisitorAnalyticsPieChartData(filter).subscribe(
      response => {
        console.log(response.data);
        this.pieData = response.data
      },
      error => {
      }
    )
  }
}
